import React, { useCallback } from 'react'
import styled from 'styled-components'
import Drawer from '@material-ui/core/Drawer'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { makeStyles } from '@material-ui/core/styles'
import { facebookShare, whatsAppShare } from 'utils/shareUtil'
import { useTrackingStore } from 'store/trackingStore'
import { BUTTON_NAME, COUPON_SCREEN_NAME, EVENT_ACTION } from 'tracking'

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '8px 8px 0 0',
  },
}))

const SharePanel = ({
  shareUrl,
  openShareAction,
  closeShareAction,
  copyLink,
  router,
}) => {
  const { pathname } = router
  const { trackEvent, isInited } = useTrackingStore()
  const screenName = pathname.substr(1).toUpperCase()

  const shareTrack = useCallback(
    (buttonName) => {
      if (isInited) {
        trackEvent(EVENT_ACTION.CLICK, {
          screen: COUPON_SCREEN_NAME[screenName],
          button: buttonName,
        })
      }
    },
    [isInited, screenName, trackEvent]
  )

  const shareToFacebook = useCallback(() => {
    shareTrack(BUTTON_NAME.CUSTOM_SHARE_FB)
    facebookShare({
      href: shareUrl,
      success: () => {
        trackEvent(EVENT_ACTION.RESPONSE, {
          screen: COUPON_SCREEN_NAME[screenName],
          button: BUTTON_NAME.CUSTOM_SHARE_FB,
          result: 'share success',
        })
      },
      fail: () => {
        trackEvent(EVENT_ACTION.RESPONSE, {
          screen: COUPON_SCREEN_NAME[screenName],
          button: BUTTON_NAME.CUSTOM_SHARE_FB,
          result: 'Error while posting facebook share',
          error_type: 'share facebook fail',
        })
      },
    })
    closeShareAction()
  }, [closeShareAction, screenName, shareTrack, shareUrl, trackEvent])

  const shareToWhatsApp = useCallback(() => {
    shareTrack(BUTTON_NAME.CUSTOM_SHARE_WHATSAPP)
    whatsAppShare(shareUrl)
    closeShareAction()
  }, [closeShareAction, shareTrack, shareUrl])

  const copyLinkToShare = useCallback(() => {
    shareTrack(BUTTON_NAME.CUSTOM_SHARE_COPY)
    copyLink()
  }, [copyLink, shareTrack])

  const closeCustomShare = () => {
    closeShareAction()
    shareTrack(BUTTON_NAME.CUSTOM_SHARE_CANCEL)
  }
  const classes = useStyles()
  return (
    <>
      <Drawer
        anchor="bottom"
        open={openShareAction}
        onClose={closeShareAction}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <ShareItem onClick={shareToFacebook}>分享到Facebook</ShareItem>
        <ShareItem onClick={shareToWhatsApp}>分享到Whatsapp</ShareItem>
        <CopyToClipboard onCopy={copyLinkToShare} text={shareUrl}>
          <ShareItem>複製鏈接</ShareItem>
        </CopyToClipboard>
        <ShareItem onClick={closeCustomShare}>取消</ShareItem>
      </Drawer>
    </>
  )
}

const ShareItem = styled.div`
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
  color: ${(p) => p.theme.color.dark200};
  width: 100%;
  border-bottom: 1px solid ${(p) => p.theme.color.grey80};
  &:last-child {
    border-bottom: 0;
  }
`

export default SharePanel
